import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.PressRoomArticleView.heading',
    defaultMessage: 'Press Room'
  },
  return: {
    id: 'views.PressRoomArticleView.return',
    defaultMessage: 'POWRÓT'
  },
  journalistContact: {
    id: 'views.PressRoomArticleView.journalistContact',
    defaultMessage: 'KONTAKT DLA DZIENNIKARZY'
  },
  filesToDownload: {
    id: 'views.PressRoomArticleView.filesToDownload',
    defaultMessage: 'ZAŁĄCZNIKI'
  },
  zipFilesToDownload: {
    id: 'views.PressRoomArticleView.zipFilesToDownload',
    defaultMessage: 'Pobierz pozostałe załączniki:'
  },
  graphicsToDownload: {
    id: 'views.PressRoomArticleView.graphicsToDownload',
    defaultMessage: 'Pobierz materiały graficzne:'
  },
  otherNews: {
    id: 'views.PressRoomArticleView.otherPressRoomNews',
    defaultMessage: 'POZOSTAŁE INFORMACJE PRASOWE'
  }
});



// WEBPACK FOOTER //
// ./src/views/PressRoomArticle/PressRoomArticleView.intl.js